const RADIUS = 38;
 
export const CIRCLE_DM = {
     RADIUS, //радиус круга
     CENTER_X: 40,
     CENTER_Y: 40,
     TRIANGLE_BASE: 15, //основание треугольника
     LINE_LENGTH_BARRIER: RADIUS + 7, //длина линий барьеров
     BARRIER_DISABLED : 65535, //признак выключенного барьера
}

export const COLORS_CIRCLE ={
    ONLINE:{
        WATER_FILL: '#2196f333',
        WATER_OUTLINE: '#1492fac7',

        NOWATER_FILL: '#ebfbee',
        NOWATER_OUTLINE: '#92f7a5',
    },
    OFFLINE: {
        FILL: '#dedcdc',
        OUTLINE: '#b8b4b4',
    }
}